import React from 'react';
import { Sun, Wind, AlertCircle, Droplets } from 'lucide-react';
import { useLanguage } from './TranslationProvider';
// Diccionario centralizado del clima por idioma (misma lista que LANGUAGES).
// La selección manual/automática de idioma controla qué texto se muestra.
interface WeatherStrings {
  sunny: string;
  wind: string;
  humidity: string;
  alert: string;
}
const WEATHER_STRINGS: Record<string, WeatherStrings> = {
  es: {
    sunny: 'Soleado',
    wind: 'Viento',
    humidity: 'Humedad',
    alert: 'Aviso de Bandera Roja (Vientos)'
  },
  en: {
    sunny: 'Sunny',
    wind: 'Wind',
    humidity: 'Humidity',
    alert: 'Red Flag Warning (Winds)'
  },
  fr: {
    sunny: 'Ensoleillé',
    wind: 'Vent',
    humidity: 'Humidité',
    alert: 'Alerte Drapeau Rouge (Vents)'
  },
  'zh-CN': {
    sunny: '晴',
    wind: '风',
    humidity: '湿度',
    alert: '红旗警告（大风）'
  },
  'zh-TW': {
    sunny: '晴',
    wind: '風',
    humidity: '濕度',
    alert: '紅旗警告（強風）'
  },
  ko: {
    sunny: '맑음',
    wind: '바람',
    humidity: '습도',
    alert: '적기 경보 (강풍)'
  },
  hy: {
    sunny: 'Արևոտ',
    wind: 'Քամի',
    humidity: 'Խոնավություն',
    alert: 'Կարմիր դրոշի նախազգուշացում (Քամիներ)'
  },
  tl: {
    sunny: 'Maaraw',
    wind: 'Hangin',
    humidity: 'Halumigmig',
    alert: 'Babala ng Pulang Bandila (Hangin)'
  }
};
export function WeatherBanner() {
  const {
    lang
  } = useLanguage();
  const t = WEATHER_STRINGS[lang] || WEATHER_STRINGS.en;
  return <div className="bg-gradient-to-r from-sky-dark via-sky to-sky-dark text-white py-3 px-4 md:px-8 text-sm flex flex-col md:flex-row justify-between items-center gap-3 z-40 relative shadow-md border-b border-sky-dark/50" data-id="element-415">
      {/* Condiciones Actuales */}
      <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 w-full md:w-auto" data-id="element-416">
        <div className="flex items-center gap-2 font-bold text-lg drop-shadow-sm" data-id="element-417">
          <Sun className="w-6 h-6 text-warm animate-[spin_10s_linear_infinite]" data-id="element-418" />
          <span className="notranslate" data-id="element-419">Sylmar: 72°F (22°C) {t.sunny}</span>
        </div>

        <div className="hidden md:block w-px h-5 bg-white/30" data-id="element-420"></div>

        <div className="flex items-center gap-2 font-medium text-white/90" data-id="element-421">
          <Wind className="w-5 h-5 text-white" data-id="element-422" />
          <span className="notranslate" data-id="element-423">{t.wind}: 15 mph NE</span>
        </div>

        <div className="hidden md:block w-px h-5 bg-white/30" data-id="element-424"></div>

        <div className="flex items-center gap-2 font-medium text-white/90" data-id="element-425">
          <Droplets className="w-5 h-5 text-white" data-id="element-426" />
          <span className="notranslate" data-id="element-427">{t.humidity}: 18%</span>
        </div>
      </div>

      {/* Alerta Meteorológica Elegante y Llamativa */}
      <div className="flex items-center gap-2 bg-red-600 text-white px-5 py-1.5 rounded-full border border-red-400 cursor-pointer hover:bg-red-700 transition-colors shadow-[0_0_10px_rgba(220,38,38,0.5)] w-full md:w-auto justify-center mt-2 md:mt-0" data-id="element-428">
        <span className="relative flex h-3 w-3" data-id="element-429">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-430"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" data-id="element-431"></span>
        </span>
        <AlertCircle className="w-4 h-4" data-id="element-432" />
        <span className="font-bold tracking-wide text-sm notranslate" data-id="element-433">
          {t.alert}
        </span>
      </div>
    </div>;
}